export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11022.ade0f8ae.jpg";